import { Component, Inject, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LayoutService } from '../../../../_metronic/core/services/layout.service';
import { userService } from '../../../../Pages/shared/Services/userService.service';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { AuthService, StylesBundleService, UtilityService,MasterLayoutService } from 'bnsights-utilities-library';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
})
export class TopbarComponent implements OnInit {
  toolbarButtonMarginClass = 'ms-1 ms-lg-3';
  toolbarButtonHeightClass = 'w-30px h-30px w-md-40px h-md-40px';
  toolbarUserAvatarHeightClass = 'symbol-30px symbol-md-40px';
  toolbarButtonIconSizeClass = 'svg-icon-1';
  headerLeft: string = 'menu';
  // Decorator wires up blockUI instance
  @BlockUI() blockUI: NgBlockUI;

  extrasQuickPanelDisplay: boolean;
  extrasLanguagesDisplay: boolean;
  extrasUserDisplay: boolean;
  extrasUserLayout: 'offcanvas' | 'dropdown';
  language:string;
  token:string;
  name:string;
  constructor(private layout: LayoutService
    ,private translate: TranslateService
    ,private authService: AuthService,
    private userService: userService,
    private router: Router,
    private stylesBundleService: StylesBundleService,
    private UtilityService: UtilityService,
    private masterLayoutService:MasterLayoutService,
    @Inject(DOCUMENT) private document: Document
    ) 
    {
    
  }

  async ngOnInit(): Promise<void> {
    // let lang = AuthService.user.profile.locale
    let lang = await this.UtilityService.getCurrentLanguage()
    localStorage.setItem('language', lang);
    this.language = lang;
    this.headerLeft = this.layout.getProp('header.left') as string;
  }
 

  switchLang(lang) {
    this.masterLayoutService.switchLang(lang,"BBSF-Bundle-English.css","BBSF-Bundle-Arabic.css")
   
    
  }
  refreshPage() {
    window.location.reload();
   }

   getResourceValue(Key) {
    return this.UtilityService.getResourceValue(Key);
  }

   async logout(event){
     this.UtilityService.stopBlockUI();
    event.preventDefault();
    event.stopPropagation();
    await this.authService.signout(); 
  }

}
